import constants from 'constants/index'

const errorMessage = (errorObject, includeKey = true, defaultError = true) => {
  if (!errorObject) return

  if (defaultError && errorObject?.response?.status === 413) {
    return constants.errors.PAYLOAD_TOO_LARGE
  }

  const errors =
    errorObject.errors ||
    errorObject?.response?.data?.error?.errors ||
    errorObject?.response?.data?.error?.message

  var errorGeneralMessage = errors ? '' : errorObject.message || ''

  if (typeof errors === 'string') return errors

  for (let key in errors) {
    let errorMessage = ` ${includeKey ? key + ' ' : ''}${errors[key]}`
    errorGeneralMessage = errorGeneralMessage.concat(errorMessage)
  }

  return errorGeneralMessage
}
export default errorMessage
